import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgXyiconLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.4312 8.66943H15.6142L16.8615 11.6824C17.3347 12.8243 17.668 13.6767 17.8616 14.2235H17.8939C18.0372 13.7947 18.3419 12.9994 18.8079 11.8378L20.0983 8.66943H22.3135L16.9368 20.9999H14.9206L16.8346 16.5449L13.4312 8.66943Z",
		fill: "#1E88E5"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.66167 6.58941C7.26924 7.46863 7.69938 8.10125 7.94133 8.48725H7.9897C8.32844 7.95114 8.7532 7.32925 9.26399 6.59477L11.0598 4H13.7482L9.35542 10.1867L13.9363 16.5825H11.2802L9.30698 13.7679C8.82307 13.0817 8.37681 12.4276 7.96818 11.8165H7.93057C7.5076 12.4527 7.06133 13.1032 6.59176 13.7679L4.62386 16.5825H2L6.58638 10.1867L2.18817 4H4.87654L6.66167 6.58941Z",
		fill: "#1E88E5"
	})]
});
export default SvgXyiconLogo;
